module.exports = __webpack_public_path__ + "static/media/google-firebase.cab78eb3.svg";